import React from "react";

export default function PaginationSmall({ pageProps, onPageChange }) {
    const currentPage = pageProps.page;

    return (
        <>
            {pageProps.totalEntries > 0 && (
                <div className="row mt-4">
                    <div className="col-12 ps-3">
                        <nav>
                            <ul className="pagination pagination-gutter pagination-primary pagination-sm no-bg">
                                <li className={`page-item page-indicator ${currentPage === 1 ? "disabled" : ""}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
                                    >
                                        <i className="la la-angle-left"></i>
                                    </button>
                                </li>

                                {pageProps.visiblePages.map((page, index) => (
                                    <li
                                        key={index}
                                        className={`page-item ${currentPage === page ? "active" : ""}`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() => onPageChange(page)}
                                        >
                                            {page}
                                        </button>
                                    </li>
                                ))}

                                <li className={`page-item page-indicator ${currentPage === pageProps.totalPages ? "disabled" : ""}`}>
                                    <button
                                        className="page-link"
                                        onClick={() =>
                                            currentPage < pageProps.totalPages && onPageChange(currentPage + 1)
                                        }
                                    >
                                        <i className="la la-angle-right"></i>
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            )}
        </>
    );
}